export default __webpack_public_path__ + "static/media/Genitals.da265ca6.svg";